<template>
    <section class="tables">
        <div class="row">
            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-body">
                        <h2 class="card-title">{{ $t('names.users.name') }}</h2>
                        <p class="card-description">{{ $t('names.users.description') }}</p>
                        <b-button variant="primary" class="mt-4 mb-4" @click="$router.push('/user/new')">{{ $t('createNewUserTitle') }}</b-button>
                        <b-table striped hover :items="userItems" :fields="fields" @row-clicked="editUserItem" class="clickable"></b-table>
                    </div>

                    <hr/>
                    <h5 class="card-body">{{ $t('roles.description') }}</h5>
                    <b-list-group class="card-body mb-4">
                        <b-list-group-item>
                            <h6 class="mb-1">{{ $t('roles.superAdmin') }}</h6>
                            <p class="mb-0 text-gray">{{ $t('roles.superAdminDescription') }}</p>
                        </b-list-group-item>

                        <b-list-group-item>
                            <h6 class="mb-1">{{ $t('roles.admin') }}</h6>
                            <p class="mb-0 text-gray">{{ $t('roles.adminDescription') }}</p>
                        </b-list-group-item>

                        <b-list-group-item>
                            <h6 class="mb-1">{{ $t('roles.cms') }}</h6>
                            <p class="mb-0 text-gray">{{ $t('roles.cmsDescription') }}</p>
                        </b-list-group-item>

                        <b-list-group-item>
                            <h6 class="mb-1">{{ $t('roles.orders') }}</h6>
                            <p class="mb-0 text-gray">{{ $t('roles.ordersDescription') }}</p>
                        </b-list-group-item>
                    </b-list-group>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
import axios from 'axios'
import {Const} from '../../../config'

export default {
    name: 'UserList',
    data() {
        return {
            userItems: [],
            fields: [
                {
                    key: 'id',
                    label: 'ID',
                    sortable: true,
                    thStyle: 'width: 75px;'
                },
                {
                    key: 'email',
                    label: this.$t('forms.username'),
                    sortable: true
                },
                {
                    key: 'role.name',
                    label: this.$t('forms.role'),
                    sortable: true,
                    formatter: value => {
                        return this.humanRole(value)
                    }
                },
                {
                    key: 'forcePasswordChange',
                    label: this.$t('forms.passwordChangeRequired'),
                    sortable: true,
                    formatter: value => {
                        return this.humanDecision(value)
                    }
                }
            ]
        }
    },
    mounted() {
        axios.get(Const.API_HOST + '/admin/users')
                .then(response => response.data).then(body => {
            this.userItems = body
        }).catch(error => {
            // eslint-disable-next-line no-console
            console.error(error)
        })
    },
    methods: {
        editUserItem(item) {
            this.$router.push('/user/edit/' + item.id)
        },
        humanRole(value) {
            if (value === 'ROLE_ADMIN') {
                return this.$t('roles.admin')
            } else if (value === 'ROLE_ORDERS') {
                return this.$t('roles.orders')
            } else if (value === 'ROLE_CMS_ADMIN') {
                return this.$t('roles.cms')
            } else if (value === 'ROLE_SUPER_ADMIN') {
                return this.$t('roles.superAdmin')
            } else {
                return this.$t('roles.unknown')
            }
        },
        humanDecision(value) {
            if (value === true) {
                return this.$t('forms.yes')
            } else {
                return this.$t('forms.no')
            }
        },
    }
}
</script>

<style scoped>
.clickable /deep/ tbody td {
    cursor: pointer;
}

</style>
